// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-search-dialog[data-v-63364a5c]  .el-dialog{-webkit-box-shadow:unset !important;box-shadow:unset !important;border-radius:0 !important;background:rgba(0,0,0,.5)}.layout-search-dialog[data-v-63364a5c]  .el-autocomplete{width:560px;position:absolute;top:100px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}[data-v-63364a5c] .el-dialog__header{border:none !important}[data-v-63364a5c] .el-input--small .el-input__inner{height:36px;line-height:36px}", ""]);
// Exports
module.exports = exports;
